import { render, staticRenderFns } from "./Raport_produse_deviz_list.vue?vue&type=template&id=61a8fbf0&scoped=true"
import script from "./Raport_produse_deviz_list.vue?vue&type=script&lang=js"
export * from "./Raport_produse_deviz_list.vue?vue&type=script&lang=js"
import style0 from "./Raport_produse_deviz_list.vue?vue&type=style&index=0&id=61a8fbf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8fbf0",
  null
  
)

export default component.exports